import {
	CDN_PREVIEW_URL,
	CDN_URL,
	RECURSIVE_CONTENT_URL,
	RECURSIVE_RENDERER_IMAGE_SIZE,
	RECURSIVE_RENDERER_URL,
	RECURSIVE_RENDERER_VERSION,
	RENDER_URL,
} from './constants'

type GetInscriptionContentRenderTargetArgs = {
	id: string
	contentType?: string | null
	preferStaticRenderer: boolean
	// Square screenshot edge in px; the renderer's viewport is this size too.
	rendererSize?: number
	slug?: string | null
}

/// Preview rasters flatten animation and blur pixel art. Those stay on the
/// original bytes.
export function keepsOriginalInscriptionArt(contentType?: string | null, slug?: string | null): boolean {
	const type = contentType?.toLowerCase() || ''
	if (type.includes('image/gif') || type.includes('image/webp')) return true
	return Boolean(slug && PIXEL_ART_COLLECTION_SLUGS.has(slug))
}

const PIXEL_ART_COLLECTION_SLUGS = new Set(['bitcoin-puppets', 'bitcoinpunks', 'nodemonkes'])

export function getInscriptionContentRenderTarget({
	id,
	contentType,
	preferStaticRenderer,
	rendererSize = RECURSIVE_RENDERER_IMAGE_SIZE,
	slug,
}: GetInscriptionContentRenderTargetArgs) {
	const isSvg = contentType?.includes('image/svg')
	const isHtml = contentType?.includes('text/html')
	const isModel = contentType?.includes('model')
	const isNoContentType = contentType === 'no_content_type'
	const isRaster = Boolean(contentType?.includes('image')) && !isSvg
	let url
	let showScreenshot = false

	if (preferStaticRenderer && (isHtml || isSvg || isModel || isNoContentType)) {
		const mode = isModel ? '&mode=model' : ''
		url = `${RECURSIVE_RENDERER_URL}/${encodeURIComponent(id)}?size=${rendererSize}&v=${encodeURIComponent(RECURSIVE_RENDERER_VERSION)}${mode}`
		showScreenshot = true
	} else if (preferStaticRenderer && isRaster && !keepsOriginalInscriptionArt(contentType, slug)) {
		// Card and rail thumbnails. The content endpoint is the full inscription
		// (multi-megabyte PNGs). The preview endpoint is a small raster.
		url = `${CDN_PREVIEW_URL}/${id}`
	} else if (isSvg) {
		url = `${RENDER_URL}/${id}`
	} else if (isHtml) {
		url = `${RECURSIVE_CONTENT_URL}/${id}`
	} else {
		url = `${CDN_URL}/${id}`
	}

	return {
		url,
		showScreenshot,
		is_image: Boolean(contentType?.includes('image')),
	}
}
